import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { ClientWindowSticker } from 'src/app/model/product/windowsticker/client-windowsticker';
import { isStandardStickerPart } from 'src/app/model/product/windowsticker/standard-sticker-part';
import { isStickerPart } from 'src/app/model/product/windowsticker/sticker-part';

export class ClientWindowStickerSummaryHelper {
  private constructor() {}

  static calculateTypeLabel(windowSticker: ClientWindowSticker): string {
    if (
      windowSticker == null ||
      !CollectionHelper.isPopulated(windowSticker.clientStickerParts)
    ) {
      return 'Raamsticker';
    }

    let standardPartSeen = false;
    let customPartSeen = false;

    for (const part of windowSticker.clientStickerParts) {
      if (part.instance == null) {
        continue;
      }
      if (isStandardStickerPart(part.instance)) {
        standardPartSeen = true;
      } else if (isStickerPart(part.instance)) {
        customPartSeen = true;
      }
      if (standardPartSeen && customPartSeen) {
        return 'Raamsticker';
      }
    }

    if (!(standardPartSeen || customPartSeen)) {
      return 'Raamsticker';
    } else if (standardPartSeen) {
      return 'Raamsticker (S)';
    } else {
      return 'Raamsticker (M)';
    }
  }
}
